import { META_PIXEL_ID } from '../config/metaPixel';

const PREFIX = '[Daiv Meta Pixel]';

/** Opt-in only: set REACT_APP_META_PIXEL_DEBUG=true in .env to enable console logs. */
export function isMetaPixelDebugEnabled() {
  return process.env.REACT_APP_META_PIXEL_DEBUG === 'true';
  // return process.env.NODE_ENV === 'development';
}

export function logMetaPixelDebug(message, data) {
  if (!isMetaPixelDebugEnabled()) return;
  if (data !== undefined) {
    // eslint-disable-next-line no-console
    console.info(PREFIX, message, data);
  } else {
    // eslint-disable-next-line no-console
    console.info(PREFIX, message);
  }
}

export function logMetaPixelEvent(eventName, payload, meta) {
  if (!isMetaPixelDebugEnabled()) return;
  // eslint-disable-next-line no-console
  console.info(PREFIX, `track → ${eventName}`, { pixelId: META_PIXEL_ID, payload, ...meta });
}

export function logMetaPixelSkipped(eventName, reason, meta) {
  if (!isMetaPixelDebugEnabled()) return;
  // eslint-disable-next-line no-console
  console.info(PREFIX, `skip ${eventName} (${reason})`, meta || '');
}

export function buildMetaPixelDiagReport() {
  if (typeof window === 'undefined') return null;
  let pixels = [];
  let fbqVersion = null;
  try {
    pixels = window.fbq?.getState?.()?.pixels || [];
    fbqVersion = window.fbq?.version ?? null;
  } catch {
    /* ignore */
  }
  const ours = pixels.find((p) => String(p.id) === String(META_PIXEL_ID));
  const fbp = document.cookie.match(/_fbp=([^;]+)/)?.[1] || null;
  return {
    pixelId: META_PIXEL_ID,
    url: window.location.href,
    fbqLoaded: typeof window.fbq === 'function',
    fbqVersion,
    fbqIdentityOk: window._fbq === window.fbq,
    pixelRegistered: !!ours,
    eventCount: ours?.eventCount ?? 0,
    fbpCookie: fbp,
    htmlInitSnippet: document.documentElement.innerHTML.includes(`fbq('init', '${META_PIXEL_ID}')`),
    fbeventsScript: !!document.querySelector('script[src*="fbevents.js"]'),
  };
}

export function logMetaPixelDiag(label = 'diagnostic') {
  const report = buildMetaPixelDiagReport();
  if (!report) return null;
  logMetaPixelDebug(label, report);
  return report;
}

/** Poll until fbevents registers pixel (or timeout). */
export function scheduleMetaPixelFollowUpLogs() {
  if (!isMetaPixelDebugEnabled() || typeof window === 'undefined') return;

  let attempts = 0;
  const timer = window.setInterval(() => {
    attempts += 1;
    const report = buildMetaPixelDiagReport();
    if (report?.pixelRegistered || attempts >= 20) {
      logMetaPixelDebug(report?.pixelRegistered ? 'fbevents ready ✓' : 'fbevents timeout ✗', report);
      window.clearInterval(timer);
    }
  }, 500);
}

if (typeof window !== 'undefined') {
  window.__daivPixelDiag = () => {
    const report = buildMetaPixelDiagReport();
    if (report) {
      // eslint-disable-next-line no-console
      console.info(PREFIX, 'manual diagnostic', report);
    }
    return report;
  };
}
